var map = {
	"./N3Lexer": 82,
	"./N3Lexer.js": 82,
	"./N3Parser": 81,
	"./N3Parser.js": 81,
	"./N3Store": 127,
	"./N3Store.js": 127,
	"./N3StreamParser": 126,
	"./N3StreamParser.js": 126,
	"./N3StreamWriter": 125,
	"./N3StreamWriter.js": 125,
	"./N3Util": 80,
	"./N3Util.js": 80,
	"./N3Writer": 79,
	"./N3Writer.js": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 243;